<template>
  <!-- 微动画 -->
  <div class="micro-animation">
    <div class="play-video-box">
      <div class="prism-player" id="J_prismPlayer" v-if="isshowVideo"></div>
      <div class="video-controls">
        <em
          @click="changeType"
          class="controls-btn"
          :class="{
            'pause-icon': plsyStatus == 'play',
            'play-icon': plsyStatus == 'paused',
            'replay-icon': plsyStatus == 'ended',
          }"
        ></em>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MicroAnimation",
  props: ["videoSrc", "videoPoster", "from"],
  data() {
    return {
      plsyStatus: "play",
      playObj: {},
      playState: true,
      isId: "",
      isshowVideo: true,
      videoConfig: [
        {
          name: "timeDisplay",
          align: "tl",
          x: 10,
          y: 7,
        },
        {
          name: "fullScreenButton",
          align: "tr",
          x: 10,
          y: 12,
        },
        {
          name: "volume",
          align: "tr",
          x: 5,
          y: 10,
        },
      ],
    };
  },
  methods: {
    changeType(p1, p2) {
      // this.$emit("changeType", p1, p2);
      if (this.playState == true) {
        console.log(this.playObj);
        this.plsyStatus = "paused";
        this.playObj.pause();
        this.playState = false;
      } else {
        this.playState = true;
        this.plsyStatus = "play";
        this.playObj.play();
      }
    },

    init() {
      var _this = this;
      this.playObj = new Aliplayer(
        {
          id: "J_prismPlayer",
          source: this.videoSrc,
          width: "100%",
          height: "97%",
          autoplay: true,
          isLive: false,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: "hover",
          useH5Prism: true,
          skinLayout: [
            {
              name: "bigPlayButton",
              align: "blabs",
              x: 30,
              y: 80,
            },
            {
              name: "H5Loading",
              align: "cc",
            },
            {
              name: "errorDisplay",
              align: "tlabs",
              x: 0,
              y: 0,
            },
            {
              name: "infoDisplay",
            },
            {
              name: "tooltip",
              align: "blabs",
              x: 0,
              y: 56,
            },
            {
              name: "thumbnail",
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: this.videoConfig,
            },
          ],
        },
        function(player) {
          let video = document.querySelector("#J_prismPlayer video");
          video.setAttribute("controlslist", "nodownload");
          video.setAttribute("disablePictureInPicture", true);
          player.play();
          video.addEventListener(
            "ended",
            () => {
              console.log("ended");
              _this.plsyStatus = "ended";
              _this.playState = false;
              _this.$emit("submitEnd", _this.from);
            },
            false
          );
        }
      );
    },
  },
  created() {
    this.isId = this.$route.query.id;
    console.log(this.from, this.videoSrc);
    // if (this.from == 'video') {
    // 播放器进度条
    // this.videoConfig.push({ name: "progress", align: "blabs", x: 0, y: 44})
    // }
  },
  watch: {
    videoSrc(n) {
      this.init();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>

<style lang="less">
.prism-tooltip {
  color: white;
}
.controls-btn {
  width: 40px !important;
  height: 40px !important;
}
</style>
